import React, { useState } from 'react';
import { ThumbsUp, Share2, ChevronDown, ChevronUp, BadgeCheck, CornerDownRight } from 'lucide-react';
import { TrustpilotStars } from './StarRating';

const ReviewCard = ({ review }) => {
  const [showResponse, setShowResponse] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const shouldTruncate = review.content && review.content.length > 200;
  const displayContent = shouldTruncate && !expanded
    ? review.content.substring(0, 200) + '...'
    : review.content;

  return (
    <div className="border-b border-gray-200 py-6">
      {/* Review Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-semibold text-sm">
            {review.author.charAt(0)}
          </div>
          <div>
            <p className="font-medium text-[#1a1a1a]">{review.author}</p>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <span>1 avis</span>
            </div>
          </div>
        </div>
      </div>

      {/* Rating and Date */}
      <div className="flex items-center gap-3 mb-3">
        <TrustpilotStars rating={review.rating} size="sm" />
        {review.verified && (
          <span className="inline-flex items-center gap-1 text-xs text-gray-600 bg-gray-100 px-2 py-0.5 rounded">
            <BadgeCheck className="w-3 h-3" />
            Vérifié
          </span>
        )}
        {review.redirected && (
          <span className="text-xs text-gray-500">Redirigé</span>
        )}
      </div>

      {/* Review Title */}
      {review.title && (
        <h3 className="font-semibold text-[#1a1a1a] mb-2">{review.title}</h3>
      )}

      {/* Review Content */}
      <p className="text-gray-700 text-sm leading-relaxed mb-2">
        {displayContent}
      </p>
      {shouldTruncate && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-sm text-[#1a1a1a] font-medium hover:underline mb-2"
        >
          {expanded ? 'Voir moins' : 'Voir plus'}
        </button>
      )}

      {/* Experience Date */}
      <p className="text-xs text-gray-500 mb-3">
        <span className="font-medium">Date de l'expérience :</span> {review.experienceDate}
      </p>

      {/* Company Response Indicator */}
      {review.hasCompanyResponse && (
        <button
          onClick={() => setShowResponse(!showResponse)}
          className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#1a1a1a] mb-3 transition-colors"
        >
          <CornerDownRight className="w-4 h-4" />
          <span>L'entreprise a répondu</span>
          {showResponse ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </button>
      )}

      {/* Company Response */}
      {showResponse && review.companyResponse && (
        <div className="ml-6 pl-4 border-l-2 border-gray-200 mb-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-medium text-[#1a1a1a]">Réponse : Alecc</span>
            <span className="text-xs text-gray-500">{review.companyResponse.date}</span>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed">
            {review.companyResponse.content}
          </p>
        </div>
      )}

      {/* Actions */}
      <div className="flex items-center gap-4">
        <button className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#1a1a1a] transition-colors">
          <ThumbsUp className="w-4 h-4" />
          <span>Utile</span>
        </button>
        <button className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#1a1a1a] transition-colors">
          <Share2 className="w-4 h-4" />
          <span>Partager</span>
        </button>
      </div>

      {/* Review Date */}
      <p className="text-xs text-gray-400 mt-3">{review.date}</p>
    </div>
  );
};

export default ReviewCard;
